
import { ref } from 'vue'
export default {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup() {
    const isVisible = ref(false)

    function toggleVisibility() {
      isVisible.value = !isVisible.value
    }

    return { isVisible, toggleVisibility }
  },
  props: {
    randomKoreanNumber: {
      type: Object,
      required: true,
    },
  },
}
